module.exports = __webpack_public_path__ + "static/status_ticketing.a235d3cb.png";